<div class="date-selector">
  <div class="title">{{ "DASHBOARD.DATE_SELECTOR_title" | translate }}</div>
  <div class="date-list">
    <div (click)="onSelect(dateType)" *ngFor="let dateType of dateTypes"
         [class.selected]="currentDateType.dateType === dateType.dateType" class="date-item">
      {{dateType.title}}
    </div>
  </div>
</div>
